import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { Video } from '../types';
import { API_BASE_URL } from '../services/api';
import VideoPlayer from './VideoPlayer';

interface VideoCardProps {
  video: Video;
}

const VideoCard: React.FC<VideoCardProps> = ({ video }) => {
  const [showPlayer, setShowPlayer] = useState(false);

  const handleClick = () => {
    setShowPlayer(true);
  };

  const handleClose = () => {
    setShowPlayer(false);
  };

  const formatTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);
    return date.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <>
      <Card onClick={handleClick} style={{ cursor: 'pointer' }}>
        <Card.Img variant="top" src={`${API_BASE_URL}${video.preview_url}`} alt="Preview" />
        <Card.Body>
          <Card.Text>{formatTimestamp(video.timestamp)}</Card.Text>
        </Card.Body>
      </Card>
      <VideoPlayer show={showPlayer} onHide={handleClose} video={video} />
    </>
  );
};

export default VideoCard;